import styled from 'styled-components';

export const CardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  background: ${(props) => props.isActive ? `${props.theme.colors.celticBlue}0D`: props.theme.colors.white};
  border-radius: 8px;
  border: ${props => props.isActive ? 'none' : `1px solid ${props.theme.colors.clearGray}`};
  width: fit-content;
`;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;

  & .MuiFormControlLabel-root{
    margin-left: 0;
    margin-right:0;
  }

  & .MuiFormControlLabel-root > .MuiSwitch-root{
      margin-bottom: 0;
  }


`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: ${(props) => props.theme.colors.black};
`;

export const Description = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.colors.darkGray};
  line-height: 1.4;
`;


